module.exports = __webpack_public_path__ + "static/FutureOfTransport_p6.ca25eeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FutureOfTransport/FutureOfTransport_p6.png
// module id = 523
// module chunks = 202548274545758